<template>
<div class="featured-dorms section">
    <div class="vld-parent mycenter">
      <loading :active.sync="isLoading" 
      :is-full-page="fullPage"></loading>
    </div> 
  <container>
    <div class="section__header mycenter">
<!--     <p>&nbsp;</p>
             <p>&nbsp;</p>  
              <p>&nbsp;</p>  
      <div class="section__title">
        <span class="color-pink">{{branchedDormTitle}}</span> Şubeleri
      </div> -->
      <div class="section__right">
        <!--<div v-for="(city,index) in cities" :key="city.id">-->
          <!--<SubpageCategory :links="city" @click.native="handleClickNavItem(index)" :class="{active : index===currentNav}" class="DesktopTab"/>-->
        <!--</div>-->
<!--         <div class="subpage-nav__list DesktopTab">
          <div class="subpage-nav__item" v-if="currentNav !== null">
            <button class="subpage-nav__link" @click="clearFilter">
              <span class="button__wrp">
                <span class="btn-txt">
                  See All
                </span>
              </span>
            </button>
          </div>
        </div> -->

        <div class="mobileTab">
          <select-box :options="cities" title="Select Genre"/>
        </div>

        <!--<div class="mobileTab">-->
          <!--<select-box :options="linkMobile" title="İl Seçiniz"/>-->
        <!--</div>-->
      </div>
    </div>

    <div class="featured-dorms__cnt">
      <div class="featured-dorms__list dorm-card__list">
        <swiper :options="swiperOption" style="display: none">
          <swiper-slide
            v-for="movie in movies"
            :key="movie.id"
            class="featured-dorms__col col-xl-3 col-lg-3 col-md-4">
            <movie-card
              :movie="movie"
            />
          </swiper-slide>
          <div class="swiper-paginations" style="text-align: center;" slot="pagination"></div>
        </swiper>
        <div
          v-for="movie in movies"
          :key="movie.id"
          class="featured-dorms__col desktop-dorm col-xl-3 col-lg-3 col-md-4">
          <movie-card
            :movie="movie"
          />
        </div>
        <empty-content :content="emptyContent" v-if="movies.length === 0"/>
      </div>


    </div>

  </container>
</div>
</template>

<script>
import MovieCard from '@/components/MovieCard'
import SubpageCategory from '@/components/SubpageCategory'
import SelectBox from '@/components/SelectBox'
import EmptyContent from '@/components/EmptyContent'
import axios from 'axios'
import { SET_TOTAL_RESULTS } from '@/store/mutations.type'
export default {
  name: 'BranchedDorms',
  components: {
    EmptyContent,
    MovieCard,
    SelectBox
  },
  data () {
    return {
      dormGender: '',
      branchedDormTitle: '',
      isLoading: false,
      fullPage: true,       
      currentNav: null,
      movies: [],
      allDorms: [],
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 20,
        slidesPerGroup: 2,
        breakpoints: {
          640: {
            slidesPerView: 'auto',
            centeredSlides: 'center',
            slidesPerGroup: 1
          },
          320: {
            slidesPerView: 'auto',
            centeredSlides: false,
            slidesPerGroup: 1

          }
        },
        pagination: {
          el: '.swiper-paginations',
          clickable: true
        }
      },
      cities: [],
/*       linkMobile: [
        {
          name: 'İstanbul'
        },
        {
          name: 'Ankara'
        },
        {
          name: 'Sakarya'
        },
        {
          name: 'İzmir'
        },
        {
          name: 'Afyon'
        }

      ], */
      emptyContent: {
        icon: 'icon-search',
        title: 'No Result!',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda dolor, dolorem fugit in quis velit!'
      },
      mainDorms: []
    }
  },
  methods: {
  getMovies() {
    const id = window.localStorage.getItem('branchedDormId')
    var self = this
       const url = `/3/collection/${this.$route.params.id}?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US`
       axios.get(url)
         .then(response => {
           self.$store.commit(SET_TOTAL_RESULTS, response.data.parts.length)
           this.isLoading = false
           self.movies = response.data.parts
           /*
           self.detail = response.data
           if(response.data.branches) {
             self.dorms = response.data.branches
             self.allDorms = response.data.branches
           }*/
    })
  },
  getFilteredDorms() {
    const id = window.localStorage.getItem('branchedDormId')
    var self = this
        // const url = self.$attrs.redirect ? `/site/dorm/detail/old/${dormID}` : `/site/dorm/detail/${this.$route.params.id}`
       const url = `/site/dorm/detail/${id}`
       axios.get(url)
         .then(response => {
           this.isLoading = false
           self.detail = response.data
           if(response.data.branches) {
             // self.branchedBanner = true
            // self.dorms = response.data.branches
             // self.$router.push('/subeler')
           }
           if(self.dormGender === 'erkek') {
             self.movies = []
                this.allDorms.forEach(item => {
                    if(item.dorm_type_id === 1) {
                self.movies.push(item)
                    }
              })            
           } 
           else if(self.dormGender === 'kiz') {
             self.movies = []
                this.allDorms.forEach(item => {
                    if(item.dorm_type_id === 2) {
                self.movies.push(item)
                    }
              })            
           } 
           else {
             self.movies = this.allDorms
             // self.allDorms = response.data.branches
           }
           
    })
  },        

    getBranchName() {
      let branchedDormTitle = window.localStorage.getItem('branchedDormTitle')
      return branchedDormTitle
    }
  },
  created () {
    this.getMovies()
    this.branchedDormTitle = window.localStorage.getItem('branchedDormTitle')
  },
  watch: {
    $route () {
    this.dormGender = window.localStorage.getItem('dormGender')
   // this.getFilteredDorms()
    }
  },  
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/components/featured-dorms";

.mycenter {
 display:table;
 margin:0 auto;
}
</style>
